import { API } from 'global/api'
import type { ReferralCodeResponse, ReferralRewardDetailResponse } from 'global/types/responses'
import { api, headers } from './api'

const referralCodeApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getReferralCode: builder.query<ReferralCodeResponse, void>({
      query: () => ({
        url: API.REFERRAL_CODE_URL,
        method: 'GET',
        headers: headers()
      })
    }),
    getReferralRewardDetail: builder.query<ReferralRewardDetailResponse, string>({
      query: (paymentPkId) => ({
        url: API.REFERRAL_REWARD_DETAIL_URL.replace('{paymentPkId}', paymentPkId),
        method: 'GET',
        headers: headers()
      })
    })
  })
})

export const { useGetReferralCodeQuery, useLazyGetReferralRewardDetailQuery } = referralCodeApi
